var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"search-result-span"},_vm._l((_vm.results),function(searchResult){return _c('search-result',{key:searchResult.url,attrs:{"url":searchResult.url,"title":searchResult.title,"description":_vm.getDescription(searchResult)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }